import { createI13nNode } from 'react-i13n';
import { NavLink } from 'react-router-dom';

import { I13N_ACTION_NAVIGATE } from 'Lib/constants/i13nSpec';

import { makePure } from './makePure';

// preventing react-i13n's innerRef prop from propogating down to NavLink
const NavLinkOmitRef = ({
  innerRef,
  ...rest
}: React.ComponentProps<typeof NavLink> & { innerRef: React.RefCallback<unknown> }) => (
  <NavLink {...rest} />
);

const I13nNavLinkBase = createI13nNode(
  NavLinkOmitRef,
  {},
  {
    skipUtilFunctionsByProps: true,
  }
);

export default makePure(I13nNavLinkBase, { action: I13N_ACTION_NAVIGATE });
